/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './EnergiaSolarEconomia.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
import RedButton from '@/components/atoms/RedButton';

function EnergiaSolarEconomia() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="energia-solar-economia">
        <div className="energia-solar-economia-p1">
          <ContainerHome24>
            <div className="economia-textos">
              <img
                src="assets/energia-solar/ic_services_sustainable.svg"
                alt="icone"
                className="economia-textos-icone"
              />
              <h2 className="economia-textos-titulo">
                Reduza até 95% na sua conta de luz com energia Solar
              </h2>
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width < 992 && (
                    <picture>
                      <source type="image/webp" srcSet="assets/energia-solar/img-economia.webp" />
                      <source type="image/png" srcSet="assets/energia-solar/img-economia.png" />
                      <img
                        src="assets/energia-solar/img-economia.png"
                        alt="Casa com painel solar no telhado, financiado por Santander, resultando em economia na conta de luz através do uso da energia solar."
                      />
                    </picture>
                  )}
                </>
              )}
              <p className="economia-textos-texto">
                Ao gerar sua própria energia, você reduz os custos com a conta de luz, ganha mais
                autonomia energética com menor dependência da distribuidora e investe em um sistema
                que pode valorizar seu imóvel.
              </p>
              <RedButton className="economia-textos-btn" href="#form-energia-solar">
                Simular
              </RedButton>
            </div>
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width >= 992 && (
                  <picture>
                    <source
                      type="image/webp"
                      srcSet="assets/energia-solar/img-economia-desk.webp"
                    />
                    <source type="image/png" srcSet="assets/energia-solar/img-economia-desk.png" />
                    <img
                      src="assets/energia-solar/img-economia-desk.png"
                      alt="Casa com painel solar no telhado, financiado por Santander, resultando em economia na conta de luz através do uso da energia solar."
                    />
                  </picture>
                )}
              </>
            )}
          </ContainerHome24>
        </div>

        <div className="energia-solar-separador">
          <CustomEmblaCarouselHome24
            // loop
            enableBullets
            detectBulletCount
            hideOverflow
            enableMobileArrows
            enablePrevArrow
            autoplay={100000}
          >
            {({ className }) => (
              <>
                <div className={`slide ${className}`}>
                  {typeof window === 'undefined' ? (
                    <></>
                  ) : (
                    <>
                      {width <= 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-1.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-1.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-1.png"
                            alt="Pessoas felizes em ter placas solares com durabilidades de até 25 anos, com painel solar no fundo."
                          />
                        </picture>
                      )}
                      {width > 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-1-desk.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-1-desk.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-1-desk.png"
                            alt="Pessoas felizes em ter placas solares com durabilidades de até 25 anos, com painel solar no fundo."
                          />
                        </picture>
                      )}
                    </>
                  )}
                </div>
                <div className={`slide ${className}`}>
                  {typeof window === 'undefined' ? (
                    <></>
                  ) : (
                    <>
                      {width <= 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-2.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-2.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-2.png"
                            alt="Painéis solares capturando a luz solar para gerar energia elétrica de forma eficiente."
                          />
                        </picture>
                      )}
                      {width > 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-2-desk.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-2-desk.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-2-desk.png"
                            alt="Painéis solares capturando a luz solar para gerar energia elétrica de forma eficiente."
                          />
                        </picture>
                      )}
                    </>
                  )}
                </div>
                <div className={`slide ${className}`}>
                  {typeof window === 'undefined' ? (
                    <></>
                  ) : (
                    <>
                      {width <= 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-3.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-3.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-3.png"
                            alt="Painéis solares instalados no telhado de um edifício, vistos de cima."
                          />
                        </picture>
                      )}
                      {width > 992 && (
                        <picture className="img-separador-vantagens">
                          {/* <source type="image/webp" srcSet="assets/energia-solar/vantagens/separador-vantagens-3-desk.webp" /> */}
                          <source
                            type="image/png"
                            srcSet="assets/energia-solar/vantagens/separador-vantagens-3-desk.png"
                          />
                          <img
                            src="assets/energia-solar/vantagens/separador-vantagens-3-desk.png"
                            alt="Painéis solares instalados no telhado de um edifício, vistos de cima."
                          />
                        </picture>
                      )}
                    </>
                  )}
                </div>
              </>
            )}
          </CustomEmblaCarouselHome24>
        </div>
      </section>

      <style jsx>{Style}</style>
    </>
  );
}

export default EnergiaSolarEconomia;
